import { Link } from 'react-router-dom';
import { Lock, SearchX } from 'lucide-react';
import { Button } from '@/components/ui/Button';

function ErrorLayout({
  icon,
  title,
  message,
}: {
  icon: React.ReactNode;
  title: string;
  message: string;
}) {
  return (
    <div className="flex min-h-dvh flex-col items-center justify-center gap-4 px-6 text-center">
      <span className="flex h-14 w-14 items-center justify-center rounded-2xl bg-sunken text-ink-muted">
        {icon}
      </span>
      <h1 className="text-xl font-semibold tracking-tight">{title}</h1>
      <p className="max-w-sm text-sm text-ink-secondary">{message}</p>
      <Button asChild variant="secondary" className="mt-2">
        <Link to="/dashboard">Back to dashboard</Link>
      </Button>
    </div>
  );
}

export function ForbiddenPage() {
  return (
    <ErrorLayout
      icon={<Lock className="h-6 w-6" strokeWidth={1.5} aria-hidden />}
      title="You do not have access to this"
      // Names the fix rather than the failure: the person who can grant it is
      // in the same shop, and saying so is faster than a support ticket.
      message="Ask your workspace owner to add the permission to your role."
    />
  );
}

export function NotFoundPage() {
  return (
    <ErrorLayout
      icon={<SearchX className="h-6 w-6" strokeWidth={1.5} aria-hidden />}
      title="Page not found"
      message="That link may be out of date, or the record may have been deleted."
    />
  );
}
